module.exports = __webpack_public_path__ + "static/media/IconRulingInactive.6e858802.svg";